// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 9 hooks for backend/whatsapp.

import { useBackend } from '../useBackend'

/** POST /api/whatsapp/getConnectStatus */
export function useGetConnectStatus<T = any>() {
  return useBackend<T>('whatsapp/getConnectStatus')
}

/** POST /api/whatsapp/getConversations */
export function useGetConversations<T = any>() {
  return useBackend<T>('whatsapp/getConversations')
}

/** POST /api/whatsapp/getInboxAccess */
export function useGetInboxAccess<T = any>() {
  return useBackend<T>('whatsapp/getInboxAccess')
}

/** POST /api/whatsapp/getMediaUrl */
export function useGetMediaUrl<T = any>() {
  return useBackend<T>('whatsapp/getMediaUrl')
}

/** POST /api/whatsapp/getTemplates */
export function useGetTemplates<T = any>() {
  return useBackend<T>('whatsapp/getTemplates')
}

/** POST /api/whatsapp/getThread */
export function useGetThread<T = any>() {
  return useBackend<T>('whatsapp/getThread')
}

/** POST /api/whatsapp/markHandled */
export function useMarkHandled<T = any>() {
  return useBackend<T>('whatsapp/markHandled')
}

/** POST /api/whatsapp/sendMessage */
export function useSendMessage<T = any>() {
  return useBackend<T>('whatsapp/sendMessage')
}

/** POST /api/whatsapp/submitConnect */
export function useSubmitConnect<T = any>() {
  return useBackend<T>('whatsapp/submitConnect')
}
